<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="6">
              <el-form-item label="状态" prop="status">
                <el-select v-model="queryCondition.status" clearable placeholder="请选择" style="width:100%">
                  <el-option v-for="item in statusLists" :label="item.name" :value="item.code" :key="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <!-- <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span> -->
          </el-row>
        </el-form>
      </div>
      <el-row>
        <el-table :data="tableData" max-height="425" border stripe style="width: 100%">
          <el-table-column prop="templateType" sortable :sort-method="(a,b) => sortMethods(a ,b , 'templateType')" label="类型" min-width="120"></el-table-column>
          <el-table-column prop="templateVersionText" sortable :sort-method="(a,b) => sortMethods(a ,b , 'templateVersionText')" label="版本" min-width="100"></el-table-column>
          <el-table-column prop="usedFlagText" sortable :sort-method="(a,b) => sortMethods(a ,b , 'usedFlagText')" label="是否已使用" min-width="120"></el-table-column>
          <el-table-column prop="statusText" sortable :sort-method="(a,b) => sortMethods(a ,b , 'statusText')" label="状态" min-width="100"></el-table-column>
          <el-table-column label="检测项维护" min-width="130">
            <template slot-scope="scope">
              <el-button @click="onTest(scope.row)" v-acl="NUTR_TEMPLATE_DETAIL_EDIT" type="text" size="small">检测指标</el-button>
            </template>
          </el-table-column>
          <el-table-column label="检测参考文件" min-width="150">
            <template slot-scope="scope">
              <el-button @click="onUpload(scope.row)" type="text" size="small">检测文件</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="comments" sortable label="备注" :sort-method="(a,b) => sortMethods(a ,b , 'comments')" show-overflow-tooltip min-width="150"></el-table-column>
          <el-table-column prop="updateByName" sortable label="更新人" :sort-method="(a,b) => sortMethods(a ,b , 'updateByName')" show-overflow-tooltip min-width="120"></el-table-column>
          <el-table-column prop="updateDate" sortable label="更新时间" :sort-method="(a,b) => sortMethods(a ,b , 'updateDate')" show-overflow-tooltip min-width="150"></el-table-column>
          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
              <el-button @click="onUpdate(scope.row)" :disabled="isUpdateDisabled" :loading="isUpdateLoading" type="text" size="small" v-if="scope.row.status==='Enable'" v-acl="NUTR_TEMPLATE_COPY_INSERT">升级版本</el-button>
              <el-button @click="onDel(scope.row)" :disabled="isDelDisabled" :loading="isDelLoading" type="text" size="small" v-if="scope.row.usedFlag==='N'&&scope.row.isDefault!='Y'" v-acl="NUTR_TEMPLATE_DELETE">删除</el-button>
              <el-button @click="onRemark(scope.row)" type="text" size="small" v-acl="NUTR_TEMPLATE_EDIT_COMMENTS" v-if="scope.row.status==='Enable'">备注</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
          </el-pagination>
        </div>
      </el-row>
      <el-dialog title="检测项维护" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false" @close="onClose">
        <el-form ref="testForm" :model="testForm">
          <el-table :data="testForm.tableData" ref="elTable" row-key="sortNum" max-height="344px" class="dragTable" border size="small" style="width: 100%">
            <el-table-column min-width="60px" v-if="usedFlag==='N'">
              <template slot="header" slot-scope="scope">
                <el-button size="mini" type="primary" plain @click="onAdd(scope.$index,scope.row)" style="padding:1px!important;backgroundColor:#f8ab01!important"><i class="el-icon-plus"></i></el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-form-item> -->
                <el-button size="mini" type="danger" @click="onDelete(scope.$index,scope.row)" style="padding:1px!important;"><i class="el-icon-delete"></i></el-button>
                <!-- </el-form-item> -->
              </template>
            </el-table-column>
            <el-table-column label="拖拽顺序" min-width="130px" v-if="usedFlag==='N'">
              <template slot-scope="scope">
                <!-- <el-form-item> -->
                <el-button size="mini" type="primary" plain @click.stop="moveUp(scope.$index,scope.row)" :disabled="scope.$index === 0" style="padding:1px!important;backgroundColor:#f8ab01!important"><i class="el-icon-top"></i></el-button>
                <el-button size="mini" type="primary" plain @click.stop="moveDown(scope.$index,scope.row)" :disabled="scope.$index === testForm.tableData.length - 1" style="padding:1px!important;backgroundColor:#f8ab01!important"><i class="el-icon-bottom"></i></el-button>
                <el-button size="mini" type="primary" plain class="allowDrag" style="padding:1px!important;backgroundColor:#f8ab01!important"><i class="el-icon-rank"></i></el-button>
                <!-- </el-form-item> -->
              </template>
            </el-table-column>
            <el-table-column prop="sortNum" label="显示顺序" min-width="80px"></el-table-column>
            <el-table-column prop="inspectName" label="检测项名称" :render-header="renderHeader" min-width="200px">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.inspectName`" :rules="tableFieldNameRules(scope.$index,scope.row)">
                  <el-input v-model="scope.row.inspectName" clearable :disabled="usedFlag==='Y'" style="width:100%"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="inspectNameInReport" label="检测项汇总名称" :render-header="renderHeader" min-width="180px">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.inspectNameInReport`" :rules="inspectNameInReportRules(scope.$index,scope.row)">
                  <el-input v-model="scope.row.inspectNameInReport" clearable :disabled="usedFlag==='Y'" style="width:100%"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" :disabled="isSaveDisabled" :loading="isSaveLoading" @click="onSave" v-if="usedFlag==='N'">保存</el-button>
          <el-button size="mini" class="btn" @click="onClose">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="检测参考文件" :visible.sync="dialogFileVisible" width="50%" :close-on-click-modal="false" @close="onCloseFile">
        <el-row class="action-btn-row">
          <el-button size="mini" class="btn" type="primary" @click="onUploadFile" v-if="usedFlag==='N'" v-acl="NUTR_TEMPLATE_ATTACHMENT_UPLOAD">上传</el-button>
        </el-row>
        <el-table :data="fileTableData" ref="fileTable" border size="small" style="width: 100%">
          <el-table-column label="附件名称" prop="documentName" show-overflow-tooltip min-width="130px">
            <template slot-scope="scope">
              <el-button type="text" @click="onDownload(scope.row)">{{scope.row.documentName}}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="文件描述" prop="docComments" show-overflow-tooltip min-width="100px"></el-table-column>
          <el-table-column label="上传人" prop="uploadBy" show-overflow-tooltip min-width="100px"></el-table-column>
          <el-table-column label="上传时间" prop="uploadTime" show-overflow-tooltip min-width="100px"></el-table-column>
          <el-table-column label="操作" min-width="120px">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="onDeleteFile(scope.$index,scope.row)" v-if="usedFlag==='N'" v-acl="NUTR_TEMPLATE_ATTACHMENT_UPLOAD" style="padding:1px!important;"><i class="el-icon-delete"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" :disabled="isFileSaveDisabled" :loading="isFileSaveLoading" @click="onSaveFile" v-if="usedFlag==='N'" v-acl="NUTR_TEMPLATE_ATTACHMENT_UPLOAD">保存</el-button>
          <el-button size="mini" class="btn" @click="onCloseFile">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="附件上传" :visible.sync="dialogUploadFileVisible" width="30%" :close-on-click-modal="false" @close="onCloseUploadFile">
        <el-form ref="fileForm" :model="fileForm" :rules="filesRules" label-width="100px">
          <el-form-item prop="files" label="选择文件">
            <el-upload ref="upload" name="file" action="" :http-request="httpRequest" :on-remove="handleRemove" :before-upload="beforeUpload">
              <el-input readonly style="width:200px;">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </el-upload>
          </el-form-item>
          <el-form-item prop="docComments" label="文件描述">
            <el-input style="width:200px;" placeholder="" type="textarea" maxlength="100" show-word-limit v-model="fileForm.docComments"></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="uploadClick">上传</el-button>
          <el-button size="mini" class="btn" @click="onCloseUploadFile">关闭</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="备注" :visible.sync="dialogVisible1" width="30%" :close-on-click-modal="false" @close="onClose1">
        <el-form ref="remarkForm" :model="remarkForm" :rules="remarkFormRules" label-width="100px">
          <el-form-item label="备注" prop="comments">
            <el-input v-model="remarkForm.comments" type="textarea" :rows="2" maxlength="1000" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center">
          <el-button size="mini" class="btn" type="primary" @click="onSave1" :disabled="isRemarkDisabled" :loading="isRemarkLoading">保存</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onClose1">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import nutriApi from "@/api/Nutrition/index";
import paginationMixin from '@/mixins/pagitionMixin';
import { fileService } from "@/api/common/file-utils"
// import store from '@/store/index'
import Sortable from "sortablejs";
import commonConstants from "@/constants/commonConstants";
export default {
  // name: 'Window',
  mixins: [paginationMixin],
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        status: "",
      },
      statusLists: [],
      totalCount: 0,
      pages: 1,
      isShow: false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogFileVisible: false,
      dialogUploadFileVisible: false,
      isUpdateDisabled: false,
      isUpdateLoading: false,
      isDelDisabled: false,
      isDelLoading: false,
      isSaveDisabled: false,
      isSaveLoading: false,
      isFileSaveDisabled: false,
      isFileSaveLoading: false,
      isRemarkDisabled: false,
      isRemarkLoading: false,
      tableData: [],
      testForm: {
        tableData: []
      },
      rules: {},
      fileTableData: [],
      fileForm: {
        files: [],
        docComments: "",
      },
      filesRules: {
        files: [
          { required: true, message: '请上传文件', trigger: 'blur' },
        ],
        docComments: [
          { required: true, message: '请输入文件描述', trigger: 'blur' },
        ],
      },
      remarkFormRules: {
        comments: [
          { required: true, message: '请输入备注', trigger: 'blur' },
        ],
      },
      usedFlag: 'N',
      templateId: null,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      remarkForm: {
        comments: "",
      },
      id: "",
    };
  },
  // watch: {
  //   queryCondition() {
  //     let _this = this;
  //     store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
  //   }
  // },
  // beforeRouteEnter(to, from, next) {
  // QIPApi.findListPage(to.meta.reqData).then((res) => {
  //   next(vm => {
  //     vm.queryCondition = to.meta.reqData;
  //     vm.tableData = res.data.records;
  //     vm.totalCount = res.data.total;
  //   })
  // })
  // },
  computed: {
    uploadUrl() {
      return commonConstants.fileUploadUrl;
    }
  },
  mounted() {
    this.queryData()
    this.getStatusLists()
  },
  methods: {
    queryData() {
      nutriApi.findTemplateQuery(this.queryCondition).then(res => {
        console.log("🚀 ~ file: detectionTemplateConfig.vue:192 ~ nutriApi.findTemplateQuery ~ res:", res)
        this.tableData = res.resultData
        this.totalCount = res.totalCount
      })
    },
    getStatusLists() {
      nutriApi.getStatusLists().then(res => {
        console.log("🚀 ~ file: detectionTemplateConfig.vue:200 ~ nutriApi.getStatusLists ~ res:", res)
        if (res.code === '200') {
          this.statusLists = res.data
        }
      })
    },
    onTest(row) {
      this.usedFlag = row.usedFlag
      this.templateId = row.templateHeaderId
      nutriApi.getTestLists(row.templateHeaderId).then(res => {
        console.log("🚀 ~ file: detectionTemplateConfig.vue:209 ~ nutriApi.getTestLists ~ res:", res)
        if (res.code === '200') {
          this.testForm.tableData = res.data
          this.dialogVisible = true
          this.$nextTick(() => {
            this.rowDrop()
          })
        }
      })
    },
    onAdd(index, row) {
      if (this.testForm.tableData.length > 0) {
        var maxNum = Math.max.apply(Math, this.testForm.tableData.map(item => { return item.sortNum }))
      } else {
        var maxNum = 0
      }
      var item = {
        sortNum: (maxNum + 1),
        inspectName: "",
        inspectNameInReport: "",
      }
      this.testForm.tableData.push(item);
    },
    onDelete(index, row) {
      this.$confirm('请确认是否删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.testForm.tableData.splice(index, 1)
        this.testForm.tableData.forEach((ele, index) => {
          this.$set(ele, 'sortNum', index + 1)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onUpload(row) {
      this.usedFlag = row.usedFlag
      this.templateId = row.templateHeaderId
      this.getFileLists(row.templateHeaderId)
    },
    getFileLists(templateId) {
      nutriApi.getFileLists(templateId).then(res => {
        console.log("🚀 ~ file: detectionTemplateConfig.vue:227 ~ nutriApi.getFileLists ~ res:", res)
        if (res.code === '200') {
          this.fileTableData = res.data
          this.dialogFileVisible = true
        }
      })
    },
    onUploadFile() {
      this.dialogUploadFileVisible = true
      this.fileForm.docComments = ''
      this.fileForm.files = []
      console.log('this.$refs.upload', this.$refs.upload)
    },
    beforeUpload(file) {
      //计算文件的大小
      const isLt50M = file.size / 1024 / 1024 < 50; //这里做文件大小限制
      //如果大于50M
      if (!isLt50M) {
        this.$message({
          message: '上传文件大小不能超过 50MB!',
          type: 'info'
        });
        return false;
      }
    },
    httpRequest(param) {
      console.log("🚀 ~ file: detectionTemplateConfig.vue:303 ~ httpRequest ~ param:", param)
      this.fileForm.files.push(param.file)
    },
    handleRemove(item) {
      console.log("🚀 ~ file: detectionTemplateConfig.vue:312 ~ handleRemove ~ item:", item)
      // console.log("11", this.$refs.upload)
      // fileList.forEach(ele=>{
      //   this.fileForm.files.push(ele)
      // })
      // this.$refs.upload.clearFiles()
      for (var i in this.fileForm.files) {
        if (item.name == this.fileForm.files[i].name) {
          this.fileForm.files.splice(i, 1)
        }
      }
      console.log("🚀 ~ file: detectionTemplateConfig.vue:316 ~ handleRemove ~ this.fileForm.files:", this.fileForm.files)
    },
    uploadClick() {
      this.$refs['fileForm'].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          this.fileForm.files.forEach((v) => {
            formData.append('file', v, v.name)
          })
          formData.append('docComments', this.fileForm.docComments)
          fileService.fileUpload(formData).then((res) => {
            console.log("🚀 ~ file: detectionTemplateConfig.vue:292 ~ fileService.fileUpload ~ res:", res)
            if (res.code == '200') {
              this.$message.success('上传成功')
              this.dialogUploadFileVisible = false
              res.data.forEach(ele => {
                ele.docComments = this.fileForm.docComments
                this.fileTableData.push(ele)
              })
              this.$refs.upload.clearFiles()
            }
          }).catch((error) => {
            //文件上传失败
            this.$message.error('文件上传失败')
          });
        }
      })
    },
    onSaveFile() {
      this.isFileSaveDisabled = true
      this.isFileSaveLoading = true
      nutriApi.saveFile(this.fileTableData, this.templateId).then(res => {
        console.log("🚀 ~ file: detectionTemplateConfig.vue:317 ~ nutriApi.saveFile ~ res:", res)
        this.isFileSaveDisabled = false
        this.isFileSaveLoading = false
        if (res.code === '200') {
          this.$message.success("保存成功")
          this.dialogFileVisible = false
        }
      })
    },
    onDownload(row) {
      fileService.downloadFile(row).then(res => {
        console.log('res', res)
      })
    },
    onDeleteFile(index, row) {
      this.$confirm('请确认是否删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileTableData.splice(index, 1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    moveUp(index, row) {
      if (index > 0) {
        this.$nextTick(() => {
          let temp = this.testForm.tableData[index - 1]
          this.$set(this.testForm.tableData, index - 1, this.testForm.tableData[index])
          this.$set(this.testForm.tableData, index, temp)
          this.testForm.tableData.forEach((ele, index) => {
            ele.sortNum = index + 1
          })
        })
      } else {
        this.$message.info("已经是第一条，不可上移");
      }
    },
    moveDown(index, row) {
      if (index === (this.testForm.tableData.length - 1)) {
        this.$message.info("已经是最后一条，不可下移");
      } else {
        this.$nextTick(() => {
          let i = this.testForm.tableData[index + 1]
          this.$set(this.testForm.tableData, index + 1, this.testForm.tableData[index])
          this.$set(this.testForm.tableData, index, i)
          this.testForm.tableData.forEach((ele, index) => {
            ele.sortNum = index + 1
          })
        })
      }
    },
    rowDrop() {
      const tbody = document.querySelector('.dragTable .el-table__body-wrapper tbody');
      console.log("🚀 ~ file: detectionTemplateConfig.vue:237 ~ rowDrop ~ tbody:", tbody)
      const that = this
      Sortable.create(tbody, {
        disabled: false,// boolean 定义是否此sortable对象是否可用，为true时sortable对象不能拖放排序等功能，为false时为可以进行排序，相当于一个开关；
        animation: 180,
        delay: 0,
        handle: '.allowDrag',
        // draggable: ".el-table__row",
        onEnd: (e) => {
          const arr = that.testForm.tableData; // 获取表数据
          const currRow = arr.splice(e.oldIndex, 1)[0]
          arr.splice(e.newIndex, 0, currRow);
          that.$nextTick(() => {
            that.testForm.tableData = arr;
            console.log("🚀 ~ file: configDetail.vue:747 ~ that.$nextTick ~  that.testForm.tableData:", this.testForm.tableData)
            that.testForm.tableData.forEach((ele, index) => {
              ele.sortNum = index + 1
            })
          })
        }
      })
    },
    onUpdate(row) {
      this.isUpdateDisabled = true
      this.isUpdateLoading = true
      nutriApi.copyTemplate(row.templateHeaderId).then(res => {
        console.log("🚀 ~ file: detectionTemplateConfig.vue:392 ~ nutriApi.copyTemplate ~ res:", res)
        this.isUpdateDisabled = false
        this.isUpdateLoading = false
        if (res.code === '200') {
          this.$message.success("升级版本成功")
          this.queryData()
        }
      })
    },
    onDel(row) {
      this.$confirm('请确认是否删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isDelDisabled = true
        this.isDelLoading = true
        nutriApi.delTemplateItem(row.templateHeaderId).then(res => {
          console.log("🚀 ~ file: detectionTemplateConfig.vue:367 ~ nutriApi.delTemplateItem ~ res:", res)
          this.isDelDisabled = false
          this.isDelLoading = false
          if (res.code == '200') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.queryData()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onRemark(row) {
      this.dialogVisible1 = true
      this.id = row.templateHeaderId
      this.remarkForm.comments = row.comments
    },
    onSave1() {
      this.$refs['remarkForm'].validate((valid) => {
        if (valid) {
          this.isRemarkDisabled = true
          this.isRemarkLoading = true
          nutriApi.editComment({
            comments: this.remarkForm.comments,
            id: this.id
          }).then(res => {
            console.log("🚀 ~ file: detectionTemplateConfig.vue:521 ~ this.$refs['remarkForm'].validate ~ res:", res)
            this.isRemarkDisabled = false
            this.isRemarkLoading = false
            if (res.code === '200') {
              this.$message.success('保存成功')
              this.onClose1()
              this.queryData()
            }
          }).catch(error => {
            this.isRemarkDisabled = false
            this.isRemarkLoading = false
          })
        }
      })
    },
    onClose1() {
      this.dialogVisible1 = false
      this.id = ''
      this.remarkForm.comments = ''
      this.$refs['remarkForm'].clearValidate();
    },
    onSave() {
      this.$refs['testForm'].validate((valid) => {
        if (valid) {
          console.log('1321312312312', this.testForm.tableData)
          this.isSaveDisabled = true
          this.isSaveLoading = true
          nutriApi.saveTest(this.testForm.tableData, this.templateId).then(res => {
            console.log("🚀 ~ file: detectionTemplateConfig.vue:350 ~ nutriApi.saveTest ~ res:", res)
            this.isSaveDisabled = false
            this.isSaveLoading = false
            if (res.code === '200') {
              this.$message.success('保存成功')
              this.dialogVisible = false
              this.queryData()
            }
          }).catch(error => {
            this.isSaveDisabled = false
            this.isSaveLoading = false
          })
        }
      })
    },
    tableFieldNameRules(index, row) {
      return (this.rules["inspectName"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              return callback(new Error('请填写检测项名称'));
            }
            var isSome = this.isRepeat(this.testForm.tableData, 'inspectName')
            console.log("🚀 ~ file: configDetail.vue:944 ~ tableFieldNameRules ~ isSome:", isSome)
            if (!isSome) {
              return callback(new Error('检测项字段名称不能相同'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    inspectNameInReportRules(index, row) {
      return (this.rules["inspectNameInReport"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$msg.error('请填写检测项汇总名称')
              return callback(new Error('请填写检测项汇总名称'));
            }
            var isSome = this.isRepeat(this.testForm.tableData, 'inspectNameInReport')
            console.log("🚀 ~ file: detectionTemplateConfig.vue:382 ~ inspectNameInReportRules ~ isSome:", isSome)
            if (!isSome) {
              // this.$msg.error('检测项字段汇总名称不能相同')
              return callback(new Error('检测项字段汇总名称不能相同'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    isRepeat(arr, key) {
      // boolean: true：不存在； false：存在重复
      var obj = {};
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][key]) {
          if (obj[arr[i][key]]) {
            return false;    // 存在
          } else {
            obj[arr[i][key]] = arr[i];
          }
        }
      }
      return true;
    },
    sortMethods(a, b, proptype) {
      var prop
      if (proptype === 'updateDate') {
        prop = 'updateDateMiss'
      }else {
        prop = proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        // return a[prop] - b[prop]; // 示例中使用数字类型的比较
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        status: "",
      }
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onClose() {
      this.dialogVisible = false
    },
    onCloseFile() {
      this.dialogFileVisible = false
    },
    onCloseUploadFile() {
      this.dialogUploadFileVisible = false
    },
    renderHeader(h, { column, $index }) {
      return h("span", [
        h("span", { class: "mandatory" }),
        h("span", column.label)
      ]);
    },
  }
}
</script>
  